import { __rest } from './../../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import Card from './Card.js';
import { MAX_VISIBLE_ITEMS } from './constants.js';
import { Wrapper } from './styles.js';

const Table = forwardRef((_a, ref) => {
    var { rows, columns, seeMoreInfoButtonText = 'ver mais informações', seeMoreInfoModalTitleText = 'mais informações', PlaceholderElement } = _a, props = __rest(_a, ["rows", "columns", "seeMoreInfoButtonText", "seeMoreInfoModalTitleText", "PlaceholderElement"]);
    const rowsWithSlicedData = rows.map((_a) => {
        var { data } = _a, rest = __rest(_a, ["data"]);
        return (Object.assign(Object.assign({}, rest), { data: data.slice(0, MAX_VISIBLE_ITEMS) }));
    });
    return (React.createElement(Wrapper, Object.assign({ ref: ref }, props), !rowsWithSlicedData.length && PlaceholderElement ? (React.createElement(React.Fragment, null, PlaceholderElement)) : (rowsWithSlicedData.map(({ key, data, detailedContent }, index) => (React.createElement(Card, { rawRows: rows, key: key, data: data, columns: columns, detailedContent: detailedContent, index: index, seeMoreInfoButtonText: seeMoreInfoButtonText, seeMoreInfoModalTitleText: seeMoreInfoModalTitleText }))))));
});
Table.displayName = 'TableMobile';

export { Table as default };
